import type { ChartFormatters } from '../types/ChartFormatters.types';
import { TIME_OPTIONS } from '../config/timeFormatters';

const formattersByLocale = new Map<string | undefined, ChartFormatters>();

function createChartFormatters(locale: string | undefined): ChartFormatters {
  return {
    dateTime: new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', ...TIME_OPTIONS }),
    time: new Intl.DateTimeFormat(locale, TIME_OPTIONS),
    value: new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }),
  };
}

export function getChartFormatters(locale: string | undefined): ChartFormatters {
  const cached = formattersByLocale.get(locale);

  if (cached) {
    return cached;
  }

  const formatters = createChartFormatters(locale);

  formattersByLocale.set(locale, formatters);

  return formatters;
}
